import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import './LegalPage.css';

const TermsOfServicePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <div className="container">
        <Link to="/" className="back-link">
          <FiArrowLeft /> Back to Home
        </Link>

        <div className="legal-content">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: January 2025</p>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              Welcome to SemperSys Corp. By accessing or using our website and services, you agree to be
              bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do
              not use our services.
            </p>
          </section>

          <section>
            <h2>2. Description of Services</h2>
            <p>
              SemperSys Corp provides technology consulting, software development, cloud services,
              cybersecurity, data analytics, and related IT services. Our services are designed to
              help businesses transform and grow through technology solutions.
            </p>
          </section>

          <section>
            <h2>3. Use of Services</h2>
            <h3>Eligibility</h3>
            <p>
              You must be at least 18 years old and have the legal capacity to enter into binding
              contracts to use our services. By using our services, you represent and warrant that
              you meet these requirements.
            </p>

            <h3>Acceptable Use</h3>
            <p>You agree not to:</p>
            <ul>
              <li>Use our services for any unlawful purpose or in violation of any applicable laws</li>
              <li>Interfere with or disrupt the integrity or performance of our services</li>
              <li>Attempt to gain unauthorized access to our systems or networks</li>
              <li>Transmit any viruses, malware, or other harmful code</li>
              <li>Impersonate any person or entity or misrepresent your affiliation</li>
              <li>Collect or harvest any information from our services without authorization</li>
            </ul>
          </section>

          <section>
            <h2>4. Intellectual Property</h2>
            <h3>Our Intellectual Property</h3>
            <p>
              All content, trademarks, logos, and intellectual property displayed on our website are
              the property of SemperSys Corp or our licensors. You may not use, reproduce, or distribute
              any content without our prior written permission.
            </p>

            <h3>Client Work</h3>
            <p>
              Unless otherwise specified in a separate agreement, upon full payment for services,
              clients receive ownership of custom work products created specifically for them.
              Pre-existing materials, frameworks, and tools remain the property of SemperSys Corp.
            </p>
          </section>

          <section>
            <h2>5. Confidentiality</h2>
            <p>
              We understand the importance of confidentiality in business relationships. We commit to
              protecting your confidential information and expect the same in return regarding our
              proprietary information, methodologies, and trade secrets.
            </p>
          </section>

          <section>
            <h2>6. Service Agreements</h2>
            <p>
              Specific services are governed by separate service agreements, statements of work (SOW),
              or contracts. In case of any conflict between these Terms and a specific service agreement,
              the service agreement shall prevail for that particular engagement.
            </p>
          </section>

          <section>
            <h2>7. Payment Terms</h2>
            <p>
              Payment terms are specified in individual service agreements. Unless otherwise agreed:
            </p>
            <ul>
              <li>Invoices are due within 30 days of receipt</li>
              <li>Late payments may incur interest charges</li>
              <li>We reserve the right to suspend services for overdue accounts</li>
              <li>All fees are non-refundable unless otherwise specified</li>
            </ul>
          </section>

          <section>
            <h2>8. Warranties and Disclaimers</h2>
            <p>
              Our services are provided "as is" and "as available." While we strive to deliver
              high-quality services, we make no warranties, express or implied, regarding:
            </p>
            <ul>
              <li>The availability or uninterrupted access to our services</li>
              <li>The accuracy, reliability, or completeness of any information</li>
              <li>The results or outcomes of using our services</li>
              <li>Fitness for a particular purpose or non-infringement</li>
            </ul>
          </section>

          <section>
            <h2>9. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, SemperSys Corp shall not be liable for any
              indirect, incidental, special, consequential, or punitive damages, including but not
              limited to loss of profits, data, or business opportunities, arising from or related
              to your use of our services.
            </p>
            <p>
              Our total liability for any claims arising under these Terms shall not exceed the
              amount paid by you for the specific services giving rise to the claim.
            </p>
          </section>

          <section>
            <h2>10. Indemnification</h2>
            <p>
              You agree to indemnify, defend, and hold harmless SemperSys Corp, its officers,
              directors, employees, and agents from any claims, damages, losses, or expenses
              (including reasonable attorney fees) arising from your use of our services or
              violation of these Terms.
            </p>
          </section>

          <section>
            <h2>11. Termination</h2>
            <p>
              We may terminate or suspend your access to our services at any time, with or without
              cause, and with or without notice. Upon termination, your right to use our services
              will immediately cease. Provisions that by their nature should survive termination
              shall remain in effect.
            </p>
          </section>

          <section>
            <h2>12. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the
              Province of Ontario, Canada, without regard to its conflict of law provisions. Any
              disputes arising under these Terms shall be subject to the exclusive jurisdiction
              of the courts located in Ontario, Canada.
            </p>
          </section>

          <section>
            <h2>13. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. We will notify users of any
              material changes by posting the updated Terms on our website. Your continued use of
              our services after such changes constitutes acceptance of the modified Terms.
            </p>
          </section>

          <section>
            <h2>14. Severability</h2>
            <p>
              If any provision of these Terms is found to be unenforceable or invalid, that provision
              shall be limited or eliminated to the minimum extent necessary, and the remaining
              provisions shall remain in full force and effect.
            </p>
          </section>

          <section>
            <h2>15. Entire Agreement</h2>
            <p>
              These Terms, together with our Privacy Policy and any applicable service agreements,
              constitute the entire agreement between you and SemperSys Corp regarding the use of
              our services.
            </p>
          </section>

          <section>
            <h2>16. Contact Us</h2>
            <p>If you have any questions about these Terms of Service, please contact us:</p>
            <div className="contact-info">
              <p><strong>SemperSys Corp</strong></p>
              <p>499 Main St S, Brampton, ON L6Y 1N7, Canada</p>
              <p>Email: <a href="mailto:support@sempersyscorp.com">support@sempersyscorp.com</a></p>
              <p>Phone: <a href="tel:+16476437182">+1 (647) 643-7182</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
